import ApiService from "../ApiService";

export default class AppService {
    static uploadImage = async (value) => {
        const instance = await ApiService();
        return instance.post("/upload/image", value);
    };
    static uploadImageV1 = async (value) => {
        const instance = await ApiService();
        return instance.post("/image", value);
    };
    static uploaderFile = async (value, target) => {
        const instance = await ApiService();

        if (target !== "") {
            return instance.post(`/uploader/${target}`, value)
        }
        
        return instance.post("/uploader", value);
    }
    static serviceCharge = async (value) => {
        const instance = await ApiService();
        return instance.get(`/service_charge`);
    };
    static serviceChargeUpdate = async (value) => {
        const instance = await ApiService();
        return instance.put(`/service_charge/hotel/${value[0].hotel_id}`, value[0]);
    };
}
